import React, { useEffect, useState } from "react";
import api from "../services/api";

function Dashboard() {

  const [stats, setStats] = useState({});
  const [students, setStudents] = useState([]);
  const [totalStudents, setTotalStudents] = useState(0);

  const [batch, setBatch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [page, setPage] = useState(1);

  const limit = 15;

  const totalPages = Math.ceil(totalStudents / limit);


  /* ---------------- LOAD STATS ---------------- */

  const loadStats = async () => {

    try {

      const res = await api.get("/access/dashboard");
      setStats(res.data.data || {});

    } catch (err) {

      console.log(err);

    }

  };


  /* ---------------- FILTER ---------------- */

  const applyFilter = async () => {

    try {

      const res = await api.post("/access/filter", {
        batch,
        start_date: startDate,
        end_date: endDate,
        page
      });

      const data = res.data.data;

      setStudents(data.students || []);
      setTotalStudents(data.total_students || 0);

    } catch (err) {

      console.log(err);

    }

  };


  useEffect(() => {

    loadStats();
    applyFilter();

  }, [page]);


  return (

    <div style={{ padding: "30px 35px" }}>

      {/* -------- PAGE TITLE -------- */}

      <div style={{ marginBottom: "25px" }}>
        <h2 style={{ margin: 0 }}>Dashboard</h2>
      </div>


      {/* -------- DASHBOARD CARDS -------- */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4,1fr)",
          gap: "20px",
          marginBottom: "35px"
        }}
      >

        {card("Total Students", stats.total_students, "👨‍🎓")}
        {card("Active Accounts", stats.active_students, "✅")}
        {card("Inactive Accounts", stats.inactive_students, "⛔")}
        {card("Total Access", stats.total_access, "📚")}

      </div>


      {/* -------- FILTER BOX -------- */}

      <div style={box}>

        <h3 style={{ marginBottom: "15px" }}>Access Filters</h3>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>

          <input
            placeholder="Batch"
            value={batch}
            onChange={(e) => setBatch(e.target.value)}
            style={input}
          />

          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={input}
          />

          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={input}
          />

          <button
            onClick={() => {
              setPage(1);
              applyFilter();
            }}
            style={button}
          >
            Apply Filter
          </button>

        </div>

      </div>


      {/* -------- TABLE -------- */}

      <div style={box}>

        <h3 style={{ marginBottom: "20px" }}>
          Filtered Students ({totalStudents})
        </h3>

        <table width="100%" cellPadding="12" style={{ borderCollapse: "collapse" }}>

          <thead style={{ background: "#f3f4f6" }}>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Batch</th>
              <th>Status</th>
              <th>Active Courses</th>
              <th>Inactive Courses</th>
            </tr>
          </thead>

          <tbody>

            {students.map((s, i) => (

              <tr key={s.id} style={{ borderBottom: "1px solid #eee" }}>

                <td>{(page - 1) * limit + i + 1}</td>

                <td>{s.first_name} {s.last_name}</td>

                <td>{s.email}</td>

                <td>{s.mobile}</td>

                <td>{s.batches}</td>

                <td>
                  <span
                    style={{
                      background: s.status === "active" ? "#2ecc71" : "#e74c3c",
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      fontSize: "12px"
                    }}
                  >
                    {s.status}
                  </span>
                </td>

                <td>
                  <span style={greenBadge}>
                    {s.active_courses}
                  </span>
                </td>

                <td>
                  <span style={redBadge}>
                    {s.inactive_courses}
                  </span>
                </td>

              </tr>

            ))}

          </tbody>

        </table>


        {/* -------- PAGINATION -------- */}

        <div
          style={{
            marginTop: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px"
          }}
        >

          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            style={button}
          >
            Prev
          </button>

          <span style={{ fontWeight: "600" }}>
            Page {page} / {totalPages || 1}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
            style={button}
          >
            Next
          </button>

        </div>

      </div>

    </div>

  );

}


/* -------- UI HELPERS -------- */

const box = {
  background: "#fff",
  padding: "22px",
  borderRadius: "8px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  marginBottom: "30px"
};

const card = (title, value, icon) => (

  <div
    style={{
      background: "#fff",
      padding: "22px",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
    }}
  >

    <div style={{ fontSize: "26px", marginBottom: "8px" }}>
      {icon}
    </div>

    <div style={{ fontSize: "22px", fontWeight: "bold" }}>
      {value || 0}
    </div>

    <div style={{ color: "#777", fontSize: "14px" }}>
      {title}
    </div>

  </div>

);


const input = {
  padding: "9px 10px",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  minWidth: "150px"
};

const button = {
  background: "#2c3e50",
  color: "#fff",
  border: "none",
  padding: "9px 16px",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "500"
};

const greenBadge = {
  background: "#27ae60",
  color: "#fff",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px"
};

const redBadge = {
  background: "#e74c3c",
  color: "#fff",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "12px"
};


export default Dashboard;